import moment from 'moment-timezone'
import { Trans } from 'react-i18next'

export const pledgeState = (pledge, translationKey) =>
  pledge.state === 'pending' ? (
    <Trans
      i18nKey={`${translationKey}.expireTime`}
      values={{
        time: pledge.business_days_until_expiration,
      }}
    />
  ) : (
    <Trans i18nKey={`organizer.sponsorPledge.status.${pledge.state}`} />
  )

export const canCancelPledge = pledge =>
  ['pending', 'accepted'].includes(pledge.state) &&
  pledge.payment_status !== 'paid'

const paymentStatusConfig = {
  unpaid: { color: 'secondary', key: 'unpaid' },
  pending: { color: 'warning', key: 'pending' },
  processing: { color: 'info', key: 'processing' },
  paid: { color: 'success', key: 'paid' },
  failed: { color: 'danger', key: 'failed' },
}

export const pledgePaymentStatus = (pledge, t) => {
  // Only show payment status for accepted pledges
  if (pledge.state !== 'accepted') {
    return null
  }

  const status = pledge.payment_status || 'unpaid'
  const config = paymentStatusConfig[status] || paymentStatusConfig.unpaid

  return (
    <span className={`badge bg-${config.color}`}>
      {t(`organizer.sponsorPledge.paymentStatus.${config.key}`)}
    </span>
  )
}

export default {
  pledgeState,
  pledgePaymentStatus,
  canCancelPledge,
}
